// extracted by mini-css-extract-plugin
export var userAuditLogHeader = "user-audit-log__header_bisV2Va0UTr4kq0lVsmo";
export var userAuditLogLoadingContainer = "user-audit-log__loading-container_zxkVBH4nVD_Ls7fPwEgY";
export var userAuditLogSectionTitle = "user-audit-log__section-title_XI0KBMyTJLL1vkn71esV";
export var userAuditLogSeparator = "user-audit-log__separator_BquOGlYpOon9mTA1vNYE";
export var userAuditLogTotalCount = "user-audit-log__total-count_kyNBHIYN7g3nVEhCSQVd";